'use client';
import { FC, useEffect, useState } from 'react';

import * as Scroll from 'react-scroll';
import styled from 'styled-components';
import debounce from 'lodash/debounce';

import { UpArrowIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

const Button = styled.button<{ visible: boolean }>`
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  width: 60px;
  height: 60px;
  position: fixed;
  bottom: 120px;
  right: 45px;
  background-color: transparent;
  border: 2px solid black;
  cursor: pointer;
  z-index: 40;
  opacity: ${({ visible }) => (visible ? '1' : '0')};
  transition: all 0.15s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    right: 25px;
    bottom: 25px;
  }
`;

const UpArrowIcons = styled.div`
  justify-content: center;
  display: flex;
`;

const ScrollToTop: FC = () => {
  const [showButton, setShowButton] = useState(false);

  const scrollHandler = () => {
    if (window.scrollY === 0) {
      setShowButton(false);
    } else setShowButton(true);
  };

  useEffect(() => {
    window.addEventListener('scroll', debounce(scrollHandler, 300));
    return () => window.removeEventListener('scroll', scrollHandler);
  }, []);

  return (
    <Button
      visible={showButton}
      onClick={() => Scroll.animateScroll.scrollToTop()}
      className='scroll-to-top-button'
    >
      <UpArrowIcons>
        <CustomIcon
          paletteColor='primaryBrand'
          icon={UpArrowIcon}
          fontSize={24}
        />
      </UpArrowIcons>
    </Button>
  );
};

export default ScrollToTop;
